/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { AboutDialogComponent } from "../../components/workspace/about-dialog/about-dialog.component";
import { AboutInfo } from "../../models/about-info";
import { SysquePopupConfig } from "../../models/sysque-popup-config";
import { PopupDialog } from "../popup-dialog.interface";

export class AboutDialog implements PopupDialog {

    create(sysquePopupConfig: SysquePopupConfig): any {
        sysquePopupConfig.component = AboutDialogComponent;
        sysquePopupConfig.data = new AboutInfo();
        (sysquePopupConfig.data as AboutInfo).companyName = "Trimble Inc.";
        (sysquePopupConfig.data as AboutInfo).productName = "SysQue Electrical";
        (sysquePopupConfig.data as AboutInfo).copyrights = "© Copyright 2025, Trimble Inc.";
        sysquePopupConfig.width = 650;
        sysquePopupConfig.height = 515;
        sysquePopupConfig.componentTitle = "";
    }

}